document.addEventListener('DOMContentLoaded', function() {
    const header = document.querySelector('.header-navigation');
    if (!header) return;

    function updateHeaderState() {
        if (window.scrollY > 10) {
            header.classList.add('scrolled');
        } else {
            header.classList.remove('scrolled');
        }
    }

    // 초기 상태 설정
    updateHeaderState();
    
    // 스크롤 이벤트 리스너 추가
    window.addEventListener('scroll', updateHeaderState);
}); 